import { render, staticRenderFns } from "./veStuRewardCount.vue?vue&type=template&id=6c0f019b&scoped=true"
import script from "./veStuRewardCount.vue?vue&type=script&lang=js"
export * from "./veStuRewardCount.vue?vue&type=script&lang=js"
import style0 from "./veStuRewardCount.vue?vue&type=style&index=0&id=6c0f019b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0f019b",
  null
  
)

export default component.exports